// Masque l'interface des fonctionnalités mises de côté (config/features.js) : tout élément marqué data-feature="nom" est caché tant que le drapeau
// de cette fonctionnalité est faux. À appeler avant de lier les fenêtres (les onglets de réglages ignorent ceux qui sont cachés).
import { FEATURES } from '../config/features.js';

/** @param {ParentNode} [root]  @param {Record<string, boolean>} [features] */
export function applyFeatureFlags(root = document, features = FEATURES) {
  for (const el of root.querySelectorAll('[data-feature]')) el.hidden = !features[el.dataset.feature];
}
